import { useCallback } from 'react';

import { useCheckoutContext } from '@zooplus/checkout-state';
import { ApplePayModernizeCheckoutButton } from '@zooplus/payment-frontend';

import {
  getPlaceOrderData,
  placeOrder,
} from '@components/preview/preview-place-order-button/place-order-utils';
import { logError } from '@services/sentry-service';
import { CHECKOUT_STATE_PROJECT_ID } from '@utilities/constants';

const ApplePayPlaceOrderButton = () => {
  const { checkoutState } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);

  const onApplePayApprove = useCallback(
    (applePayOrderId: string) => {
      if (!applePayOrderId) {
        logError(
          'ApplePayPlaceOrderButton: onApplePayApprove called with invalid applePay order ID',
        );
        return;
      }

      try {
        const placeOrderData = getPlaceOrderData(checkoutState?.stateAttributes);
        const payload = {
          applePayOrderId,
          ...placeOrderData,
        };

        placeOrder(payload);
      } catch (error) {
        logError(error);
      }
    },
    [checkoutState],
  );

  const onApplePayError = useCallback(() => {
    // We will handle onApplePayError in the follow-up story instead of blindly doing it
  }, []);

  return (
    <div data-testid="applepay-button-wrapper">
      <ApplePayModernizeCheckoutButton
        onSubmit={onApplePayApprove}
        onFatalError={onApplePayError}
      />
    </div>
  );
};

export default ApplePayPlaceOrderButton;
